'use strict';
ui.loadTemplateFile('trade.html');

const TRADE_SLOT_COUNT = 24;

class TradeDialog extends Dialog {
  _element: any;
  _otherName: any;
  _mySlotsContainer: any;
  _theirSlotsContainer: any;
  _mySlots: any[];
  _theirSlots: any[];
  _mySlotSlotNums: any[];
  _myZulyInput: any;
  _theirZulyLabel: any;
  _myLockLabel: any;
  _theirLockLabel: any;
  _confirmButton: any;
  _cancelButton: any;
  _data: any;

  constructor(trade: any) {
    super('trade.html');

    this._otherName = ui.label(this, '.othername');
    this._mySlotsContainer = ui.panel(this, '.slots.mine');
    this._theirSlotsContainer = ui.panel(this, '.slots.theirs');
    this._mySlots = [];
    this._theirSlots = [];
    this._mySlotSlotNums = [];

    for (let i = 0; i < TRADE_SLOT_COUNT; ++i) {
      const mySlot = ui.iconslot('.trade-my-slot-' + i);
      mySlot.acceptsItem(true);
      mySlot.use = () => this._removeMyItem(i);
      this._mySlotsContainer.append(mySlot);
      this._mySlots.push(mySlot);

      const theirSlot = ui.iconslot('.trade-their-slot-' + i);
      theirSlot.dragEnabled(false);
      this._theirSlotsContainer.append(theirSlot);
      this._theirSlots.push(theirSlot);
    }

    this._myZulyInput = ui.textbox(this, '.textbox.zuly.mine');
    this._myZulyInput.on('returnpressed', () => {
      const amount = parseInt(this._myZulyInput.text() || '0', 10) || 0;
      netGame.tradeSetZuly(Math.max(0, Math.min(amount, 0xffffffff)));
    });

    this._theirZulyLabel = ui.label(this, '.label.zuly.theirs');
    this._myLockLabel = ui.label(this, '.label.lock.mine');
    this._theirLockLabel = ui.label(this, '.label.lock.theirs');

    this._confirmButton = ui.button(this, '.button.confirm');
    this._confirmButton.on('clicked', () => netGame.tradeConfirm());

    this._cancelButton = ui.button(this, '.button.cancel');
    this._cancelButton.on('clicked', () => netGame.tradeCancel());

    this._data = trade;
    this._data.on('changed', this._update.bind(this));
    this._update();
  }

  _removeMyItem(slotIndex: number) {
    const slotNum = this._mySlotSlotNums[slotIndex];
    if (slotNum !== undefined) {
      netGame.tradeRemoveItem(slotNum);
    }
  }

  _update() {
    if (!this._data.exists) {
      this._mySlots.forEach((slot) => slot.clear());
      this._theirSlots.forEach((slot) => slot.clear());
      this.hide();
      return;
    }

    this.show();
    this.center();
    this._otherName.text(this._data.otherName);

    this._mySlotSlotNums = Array.from(this._data.myItems.keys());
    this._mySlots.forEach((slot, i) => {
      const slotNum = this._mySlotSlotNums[i];
      if (slotNum !== undefined) {
        slot.setItem(this._data.myItems.get(slotNum));
      } else {
        slot.clear();
      }
    });

    const theirSlotNums = Array.from(this._data.theirItems.keys());
    this._theirSlots.forEach((slot, i) => {
      const slotNum = theirSlotNums[i];
      if (slotNum !== undefined) {
        slot.setItem(this._data.theirItems.get(slotNum));
      } else {
        slot.clear();
      }
    });

    this._theirZulyLabel.text(this._data.theirZuly.toString() + ' zuly');
    this._myLockLabel.text(this._data.myConfirmed ? 'Locked' : 'Not locked');
    this._theirLockLabel.text(this._data.theirConfirmed ? 'Locked' : 'Not locked');
  }
}

ui.TradeDialog = TradeDialog;

ui.tradeDialog = (trade: any) => {
  return new ui.TradeDialog(trade);
};
